export default "__VITE_ASSET__BttXFS7E__"